<template>
  <div :id="$style.goods_list">
    <div v-show="window_flag | top_flag" :class="$style.category">
      <div :id="$style.top" v-if="top_flag">
        <div :class="$style.shop_img"></div>
      </div>
      <br />
      {{ items_data[0].category }}
    </div>

    <!-- トップ専用 What's Newを表示 -->
    <div :id="$style.top" v-if="top_flag">
      <ul>
        <li v-for="news in whats_new" :key="news.id">
          <span>{{ news.year }}</span>
          <br />
          <span>{{ news.caption }}</span>
        </li>
      </ul>
    </div>

    <!-- トップ以外の商品リストを表示 -->
    <div :id="$style.list" v-else>
      <goods-detail
        :class="$style.detail"
        v-for="item_data in items_data"
        :item_data="item_data"
        :key="item_data.id"
      ></goods-detail>
    </div>
  </div>
</template>

<script lang="ts">
import Vue from "vue";
import GoodsDetail from "@/components/molecules/GoodsDetail.vue";

export default Vue.extend({
  name: "GoodsList",

  components: {
    GoodsDetail,
  },

  props: {
    items_data: {
      type: Array,
    },
    whats_new: {
      type: Array,
    },
    top_flag: {
      type: Boolean,
      default: true,
    },
    window_flag: {
      type: Boolean,
      default: true,
    },
  },
});
</script>

<style lang="scss" module>
@media only screen and (max-width: 1023px) {
  #goods_list {
    display: flex;
    flex-direction: column;
    flex-wrap: wrap;
    margin: 0px 10px;
    margin-top: 30px;
    .category {
      font-size: 16px;
    }
    #top {
      width: 100%;
      margin-top: 35px;
      font-size: 12px;
      li {
        margin-bottom: 20px;
      }
    }
    #list {
      display: grid;
      grid-template-columns: repeat(12, 1fr);
      width: 100%;
      .detail {
        grid-column: auto/span 6;
      }
    }
  }
}
@media only screen and (min-width: 1024px) {
  #goods_list {
    display: flex;
    flex-direction: column;
    flex-wrap: wrap;
    width: 690px;
    margin-right: 90px;
    .shop_img {
      background-image: url("../../../assets/shop2.jpg");
      width: 400px;
      height: 280px;
      border-radius: 30px;
      background-size: cover;
    }
    .category {
      font-size: 22px;
      margin-left: 70px;
    }
    #top {
      width: 100%;
      margin-left: 80px;
      margin-top: 35px;
      li {
        margin-bottom: 20px;
      }
    }
    #list {
      display: grid;
      grid-template-columns: repeat(12, 1fr);
      width: 100%;
      margin-left: 40px;
      .detail {
        grid-column: auto/span 4;
      }
    }
  }
}
</style>
